const GET_DOMAINS_STARTED = 'GET_DOMAINS_STARTED';
const GET_DOMAINS_SUCCESS = 'GET_DOMAINS_SUCCESS';
const GET_DOMAINS_FAIL = 'GET_DOMAINS_FAIL';
const EDIT_CAMPAIGN_STARTED = 'EDIT_CAMPAIGN_STARTED';
const EDIT_CAMPAIGN_SUCCESS = 'EDIT_CAMPAIGN_SUCCESS';
const EDIT_CAMPAIGN_FAIL = 'EDIT_CAMPAIGN_FAIL';

const getDomains = (request, history) => {
	return {
		type: GET_DOMAINS_STARTED,
		request,
		history,
	};
};
const getDomainsSuccess = (response = []) => {
	return {
		type: GET_DOMAINS_SUCCESS,
		response,
	};
};
const getDomainsFail = () => {
	return {
		type: GET_DOMAINS_FAIL,
	};
};

const editCampaign = (request, history) => {
	return {
		type: EDIT_CAMPAIGN_STARTED,
		request,
		history,
	};
};
const editCampaignSuccess = (response = []) => {
	return {
		type: EDIT_CAMPAIGN_SUCCESS,
		response,
	};
};
const editCampaignFail = () => {
	return {
		type: EDIT_CAMPAIGN_FAIL,
	};
};

export default {
	types: {
		GET_DOMAINS_STARTED,
		GET_DOMAINS_SUCCESS,
		GET_DOMAINS_FAIL,
		EDIT_CAMPAIGN_STARTED,
		EDIT_CAMPAIGN_SUCCESS,
		EDIT_CAMPAIGN_FAIL,
	},
	creators: {
		getDomains,
		getDomainsSuccess,
		getDomainsFail,
		editCampaign,
		editCampaignSuccess,
		editCampaignFail,
	},
};
